import Vue from "vue";

const STORAGE_KEY = "siteConfig";

const createDefaultConfig = () => ({
  site_title: "",
  site_english: "",
  site_logo: "",
  site_qrcode: "",
  site_weixin: "",
  site_address: "",
  site_email: "",
  site_phone: "",
  site_mobile: "",
  site_worktime: "",
  site_icp: "",
  site_copyright: "",
});

const normalizeSiteConfig = (config = {}) => {
  const normalized = {
    ...createDefaultConfig(),
    ...(config || {}),
  };

  const phone = normalized.site_phone || normalized.site_mobile || "";
  normalized.site_phone = phone;
  normalized.site_mobile = phone;

  return normalized;
};

const state = Vue.observable({
  data: createDefaultConfig(),
  loaded: false,
  pending: null,
});

const getCachedSiteConfig = () => {
  const cachedConfig = sessionStorage.getItem(STORAGE_KEY);
  if (!cachedConfig) {
    return null;
  }

  try {
    return normalizeSiteConfig(JSON.parse(cachedConfig));
  } catch (error) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

const applySiteConfig = (config) => {
  state.data = normalizeSiteConfig(config);
  state.loaded = true;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state.data));
  return state.data;
};

const cachedConfig = getCachedSiteConfig();
if (cachedConfig) {
  state.data = cachedConfig;
  state.loaded = true;
}

const ensureSiteConfig = async (http, { force = false } = {}) => {
  if (!force && state.loaded) {
    return state.data;
  }

  if (!force && state.pending) {
    return state.pending;
  }

  state.pending = http
    .post("/getConfig")
    .then((response) => {
      if (response && response.code === 200 && response.data) {
        return applySiteConfig(response.data);
      }

      return applySiteConfig({});
    })
    .finally(() => {
      state.pending = null;
    });

  return state.pending;
};

export {
  STORAGE_KEY,
  state as siteConfigState,
  ensureSiteConfig,
  normalizeSiteConfig,
};
